/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  ContextStepUpStatusGetV2Params,
  GlobalInfoResponse,
  InitContext,
  ServerInfoResponse,
  StepUpStatus,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Stability Level**: `stable`
 */
export const contextGlobalGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GlobalInfoResponse>(
    { url: `/apix/v2/Context/global`, method: "GET", signal },
    options,
  );
};

export const getContextGlobalGetV2QueryKey = () => {
  return [`/apix/v2/Context/global`] as const;
};

export const getContextGlobalGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof contextGlobalGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextGlobalGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getContextGlobalGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contextGlobalGetV2>>
  > = ({ signal }) => contextGlobalGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contextGlobalGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ContextGlobalGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof contextGlobalGetV2>>
>;
export type ContextGlobalGetV2QueryError = ErrorType<unknown>;

export function useContextGlobalGetV2<
  TData = Awaited<ReturnType<typeof contextGlobalGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextGlobalGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getContextGlobalGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `draft`
 * @summary Gets the anonymous, cacheable bootstrap ("init") context the SPA needs before it
renders — Datadog RUM / Sentry / analytics configuration. Kept separate from
M:Clients.Api.Controllers.ContextController.GetGlobalContextInfo because that response varies per user and cannot be
cached, whereas this one is identical for every caller in an environment. See ADO 282448.
 */
export const contextInitGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<InitContext>(
    { url: `/apix/v2/Context/init`, method: "GET", signal },
    options,
  );
};

export const getContextInitGetV2QueryKey = () => {
  return [`/apix/v2/Context/init`] as const;
};

export const getContextInitGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof contextInitGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextInitGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getContextInitGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contextInitGetV2>>
  > = ({ signal }) => contextInitGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contextInitGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ContextInitGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof contextInitGetV2>>
>;
export type ContextInitGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets the anonymous, cacheable bootstrap ("init") context the SPA needs before it
renders — Datadog RUM / Sentry / analytics configuration. Kept separate from
M:Clients.Api.Controllers.ContextController.GetGlobalContextInfo because that response varies per user and cannot be
cached, whereas this one is identical for every caller in an environment. See ADO 282448.
 */

export function useContextInitGetV2<
  TData = Awaited<ReturnType<typeof contextInitGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextInitGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getContextInitGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const contextUserTokenGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<string>(
    { url: `/apix/v2/Context/user-token`, method: "GET", signal },
    options,
  );
};

export const getContextUserTokenGetV2QueryKey = () => {
  return [`/apix/v2/Context/user-token`] as const;
};

export const getContextUserTokenGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof contextUserTokenGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextUserTokenGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getContextUserTokenGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contextUserTokenGetV2>>
  > = ({ signal }) => contextUserTokenGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contextUserTokenGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ContextUserTokenGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof contextUserTokenGetV2>>
>;
export type ContextUserTokenGetV2QueryError = ErrorType<unknown>;

export function useContextUserTokenGetV2<
  TData = Awaited<ReturnType<typeof contextUserTokenGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextUserTokenGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getContextUserTokenGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Stability Level**: `stable`
 */
export const contextRequestInfoGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<ServerInfoResponse>(
    { url: `/apix/v2/Context/request-info`, method: "GET", signal },
    options,
  );
};

export const getContextRequestInfoGetV2QueryKey = () => {
  return [`/apix/v2/Context/request-info`] as const;
};

export const getContextRequestInfoGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof contextRequestInfoGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextRequestInfoGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getContextRequestInfoGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contextRequestInfoGetV2>>
  > = ({ signal }) => contextRequestInfoGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contextRequestInfoGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ContextRequestInfoGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof contextRequestInfoGetV2>>
>;
export type ContextRequestInfoGetV2QueryError = ErrorType<unknown>;

export function useContextRequestInfoGetV2<
  TData = Awaited<ReturnType<typeof contextRequestInfoGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof contextRequestInfoGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getContextRequestInfoGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Gets the current step-up authentication status for the authenticated user
 */
export const contextStepUpStatusGetV2 = (
  params?: ContextStepUpStatusGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<StepUpStatus>(
    { url: `/apix/v2/Context/step-up-status`, method: "GET", params, signal },
    options,
  );
};

export const getContextStepUpStatusGetV2QueryKey = (
  params?: ContextStepUpStatusGetV2Params,
) => {
  return [
    `/apix/v2/Context/step-up-status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getContextStepUpStatusGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof contextStepUpStatusGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: ContextStepUpStatusGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof contextStepUpStatusGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getContextStepUpStatusGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof contextStepUpStatusGetV2>>
  > = ({ signal }) => contextStepUpStatusGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof contextStepUpStatusGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ContextStepUpStatusGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof contextStepUpStatusGetV2>>
>;
export type ContextStepUpStatusGetV2QueryError = ErrorType<unknown>;

/**
 * @summary Gets the current step-up authentication status for the authenticated user
 */

export function useContextStepUpStatusGetV2<
  TData = Awaited<ReturnType<typeof contextStepUpStatusGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: ContextStepUpStatusGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof contextStepUpStatusGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getContextStepUpStatusGetV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
